// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see UnsponsoredMinorApplyStartEvent
 */
export var UnsponsoredMinorApplyStart = function (_a) {
    var customerToken = _a.customerToken, reason = _a.reason;
    return ({
        name: "UnsponsoredMinor Apply Start",
        parameters: {
            cdf_entity: "UnsponsoredMinor",
            cdf_action: "Apply",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see UnsponsoredMinorRevokeStartEvent
 */
export var UnsponsoredMinorRevokeStart = function (_a) {
    var customerToken = _a.customerToken, reason = _a.reason;
    return ({
        name: "UnsponsoredMinor Revoke Start",
        parameters: {
            cdf_entity: "UnsponsoredMinor",
            cdf_action: "Revoke",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
